import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Button, FormInput, Modal } from '@getro/rombo';
import { Radio } from '@rebass/forms/styled-components';
import { Field, Form, Formik } from 'formik';
import { useRemoveHireModal, REMOVAL_REASONS } from './hooks/useRemoveHireModal';

export const RemoveHireModal = ({ hire, onClose }) => {
  const {
    selectedReason,
    setSelectedReason,
    otherReason,
    setOtherReason,
    isOtherSelected,
    canSubmit,
    handleRemoveHire,
  } = useRemoveHireModal(hire, onClose);

  return (
    <Box data-testid="remove-hire-modal" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      {createPortal(
        <Modal
          title="Remove hire"
          isOpen
          onCancel={onClose}
          actions={
            <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button data-testid="remove-hire-btn" variant="danger" onClick={handleRemoveHire} disabled={!canSubmit}>
                Remove hire
              </Button>
            </Flex>
          }
        >
          <Text fontSize="14px" color="text.main" mb="24px">
            Remove this hire if it does not belong to make sure your metrics are accurate.
          </Text>

          <Box>
            <Text fontSize="16px" fontWeight="500" color="text.dark" mb="16px">
              Why do you want to remove this hire?
            </Text>

            <Flex flexDirection="column" sx={{ gap: '16px' }}>
              {REMOVAL_REASONS.map((reason) => (
                <Flex
                  key={reason}
                  alignItems="center"
                  onClick={() => setSelectedReason(reason)}
                  sx={{ cursor: 'pointer', gap: '8px' }}
                >
                  <Radio
                    name={reason}
                    label={reason}
                    checked={selectedReason === reason}
                    value={selectedReason === reason}
                    onChange={() => setSelectedReason(reason)}
                  />
                  <Text fontSize="14px" color="text.main">
                    {reason}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Box>

          {isOtherSelected && (
            <Formik initialValues={{ other: '' }}>
              {() => (
                <Form>
                  <Box mt="16px" ml="24px" sx={{ 'label + div': { color: 'text.main' } }}>
                    <Field
                      name="other"
                      type="text"
                      component={FormInput}
                      value={otherReason}
                      placeholder="Specify the reason..."
                      onChange={({ target }) => setOtherReason(target.value)}
                    />
                  </Box>
                </Form>
              )}
            </Formik>
          )}
        </Modal>,
        document.getElementById('portals'),
      )}
    </Box>
  );
};

RemoveHireModal.propTypes = {
  hire: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
